import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import EmitDebinSummaryBody from "./components/SummaryActions";

const PayDebinSummaryPage = () => {
    const dispatch = useDispatch();
    const { seller, recurrencyDebinAction, debinTicket } = useSelector((state) => state.debin);
    const { accounts, fetching } = useSelector((state) => state.accounts);
    const account = accounts?.find((object) => object?.cbu?.substring(9) === recurrencyDebinAction?.debin?.buyer?.cbu);
    const debitAccount = accounts.find(
        (object) => object.accountNumber === recurrencyDebinAction?.debin?.buyer?.accountNumber,
    );
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    const ActionData = {
        prestacion: recurrencyDebinAction?.debin?.debin?.lending,
        referencia: recurrencyDebinAction?.debin?.debin?.reference,
        detalle: recurrencyDebinAction?.debin?.debin?.detail,
        concepto: recurrencyDebinAction?.debin?.debin?.concept,
        moneda: recurrencyDebinAction?.debin?.debin?.currency,
        cbu: recurrencyDebinAction?.debin?.buyer?.cbu,
        seller: seller?.cuit,
        action: recurrencyDebinAction?.action,
        id: parseInt(recurrencyDebinAction?.debin?.id, 10),
        sellerName: seller?.titular,
        debitAccount,
        account,
        recurrencyDebinAction,
        idTransaction: recurrencyDebinAction?.idTransaction,
    };
    let title;
    let subtitle;
    if (recurrencyDebinAction?.action === "PAUSAR") {
        title = "debin.pause";
        subtitle = "debin.pause.subtitle";
    }
    if (recurrencyDebinAction?.action === "ELIMINAR") {
        title = "debin.eliminate";
        subtitle = "debin.eliminate.subtitle";
    }
    if (recurrencyDebinAction?.action === "ACTIVAR") {
        title = "debin.activate";
        subtitle = "debin.activate.subtitle";
    }

    useConfirmTransaction(ActionData, debinTicket, "debinPayments/action/action");
    return (
        <>
            <Notification scopeToShow="debinActions" />
            <ResponsiveHeader id={title} />
            <MainContainer showLoader={fetching}>
                <div className="container">
                    <I18n id={subtitle} />
                    <EmitDebinSummaryBody
                        sellerName={seller?.titular || recurrencyDebinAction?.sellerName}
                        seller={seller?.cuit || recurrencyDebinAction?.seller}
                        id={recurrencyDebinAction?.debin?.id}
                        prestacion={recurrencyDebinAction?.debin?.debin?.lending}
                        referencia={recurrencyDebinAction?.debin?.debin?.reference}
                        concepto={recurrencyDebinAction?.debin?.debin?.concept}
                        detalle={recurrencyDebinAction?.debin?.debin?.detail}
                        account={account}
                    />
                    <GeneralCredentialForm
                        transactionData={ActionData}
                        action={debinActions.updateRecurrencyState}
                        idActivity="change.status.debin.recurrency"
                        hideIndications
                        signData={["action"]}
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default PayDebinSummaryPage;
